var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-wrapper"},[_c('nav',{staticClass:"breadcrumbs"},[_c('ul',{staticClass:"breadcrumbs__list"},[_c('li',{staticClass:"breadcrumbs__list-item"},[_c('router-link',{attrs:{"to":_vm.parentUrl}},[_vm._v(_vm._s(_vm.parentTitle))])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumbs__list-item"},[_c('span',[_vm._v("/")]),_vm._v(" "+_vm._s(_vm.currentTitle)+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c3f305","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumbs.vue
// module id = 752
// module chunks = 1